import {gql} from '@apollo/client';

export const GetAllNpcsQuery = gql`
    query GetNPCs($adventureId: Int!) {
        getNPCs(adventureId: $adventureId) {
            npcName
            npcId
            npcLevel
        }    
    }
`

export const GetNPCByID = gql`
    query GetNPCByID($npcId: Int!) {
        getNPCByID(npcId: $npcId) {
            npcName
            npcId
            npcLevel
            Subclass {
                subclassId
                subclassName
            }
            Class {
                classId
                className
            }
            Race {
                raceName
                raceId
            }
            Subrace {
                subraceId
                subraceName
            }
            CharacterSheet {
                spellSaveDc
                spellAttackModifier
                skill_to_characterSheet {
                    proficiencyAmount
                    value
                    skill_to_characterSheetId
                    Skill {
                        skillName
                        skillId
                    }
                }
                lifepoints
                currentHitpoints
                temporaryHitpoints
                currentMana
                languages
                language_to_characterSheet {
                    language_to_characterSheetId
                    Language {
                        languageName
                        languageId
                    }
                }
                initiative
                armorClass
                ability_to_characterSheet {
                    proficiencyAmount
                    value
                    ability_to_characterSheetId
                    Ability {
                        abilityId
                        abilityName
                    }
                }
                Spell {
                    isConcentration
                    savingThrow {
                        abilityId
                        abilityName
                    }
                    spellComponents
                    spellCost
                    spellId
                    spellName
                    spellDuration
                    spellTarget
                    spellText
                    spellType
                }
                Note {
                    noteText
                    noteId
                    noteHeading
                }
                Item {
                    itemId
                    itemDescription
                    itemAmount
                }
                characterSheetId
            }
        }
    }
`